import { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { transformMimeType, validateFileHeader } from '../../../../helpers/fileValidation'

const FILE_MAX_SIZE = 3000000 // 3MB

const PDFUpload = ({ handleFieldChange, file }) => {
  const { t } = useTranslation(['create-event'])
  const [error, setError] = useState(false)
  const inputRef = useRef(null)

  const validateFile = (file) => {
    handleFieldChange({ target: { name: 'pdf', value: undefined } })
    if (file.size > FILE_MAX_SIZE) {
      return setError(t('create-event:pdfUpload.fileSizeExceeded'))
    }
    const fileType = transformMimeType(file.type)
    if (fileType !== 'pdf') {
      return setError(t('create-event:pdfUpload.unsupportedFileType'))
    }
    const reader = new FileReader()
    reader.onloadend = (e) => {
      if (e.target.readyState === FileReader.DONE) {
        const bytes = new Uint8Array(e.target.result)
        const isValid = validateFileHeader(bytes, fileType)
        if (isValid) {
          setError(false)
          handleFieldChange({ target: { name: 'pdf', value: file } })
        } else {
          setError(t('create-event:pdfUpload.unsupportedFileType'))
        }
      }
    }
    reader.readAsArrayBuffer(file)
  }
  return (
    <div className="pdf-input-wrapper">
      <input
        ref={inputRef}
        accept="application/pdf"
        type="file"
        hidden
        onChange={(e) => validateFile(e.target.files[0])}
      />
      <button
        onClick={() => inputRef.current.click()}
        className="button button-primary"
        style={{ width: 200 }}
      >
        {t('create-event:pdfUpload.uploadButton')}
      </button>
      {error && <div className="message error">{error}</div>}
      {file && (
        <div className="message success">
          {t('create-event:pdfUpload.fileUploaded', {
            fileName: typeof file === 'string' ? file : file.name,
          })}
        </div>
      )}
    </div>
  )
}

PDFUpload.propTypes = {
  handleFieldChange: PropTypes.func,
  PropTypes: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default PDFUpload
